package ru.it_mozaika.sender.common.models

import kotlinx.datetime.Instant
import kotlinx.serialization.Contextual
import kotlinx.serialization.Serializable
import kotlin.time.Duration


@Serializable
data class SegmentUpdateRequest(
    var name: String,
    var rules: Rule.RuleGroup
)

@Serializable
data class StaticSegmentUpdateRequest(
    var name: String,
    var store: String
)

@Serializable
enum class StaticSegmentEmailsAction(val ruTitle: String) {
    Add("Добавить"),
    Remove("Удалить"),
    Replace("Заменить")
}

@Serializable
data class StaticSegmentUpdateEmailsRequest(
    var emails: List<String>,
    var action: StaticSegmentEmailsAction
)

@Serializable
data class Segment(
    var id: String,
    var name: String,
    var rules: Rule.RuleGroup
)

@Serializable
data class StaticSegment(
    var name: String,
    var store: String,
    var lastUpdate: String,
    var count: Int
)

@Serializable
sealed class Rule {
    @Serializable
    data class RuleGroup(
        var andRuleOperator: Boolean = false,
        @Contextual val rules: List<Rule> = listOf()
    ) : Rule()


    @Serializable
    data class Negative(val rule: Rule) : Rule()

    @Serializable
    data class Segment(val staticSegment: Boolean = true, val id: String = "") : Rule()

    @Serializable
    data class EmailCampaign(
        val status: Int = EmailMessageStatus.SEND,
        val campaignIds: List<String>? = null,
        val compareType: Int = CompareType.UNKNOWN,
        @Contextual val duration: Duration? = null,
        @Contextual val value1: Instant? = null,
        @Contextual val value2: Instant? = null
    ) : Rule()

    @Serializable
    data class SubscribeDate(
        val listIds: List<String>,
        val compareType: Int,
        @Contextual val value1: Instant,
        @Contextual val value2: Instant? = null
    ) : Rule()

    @Serializable
    sealed class SubscriberProperty : Rule() {
        abstract val fieldId: String
        abstract val compareType: Int
        protected abstract val value1: Any?
        protected abstract val value2: Any?

        @Serializable
        data class StringDataRule(
            override val fieldId: String,
            override val compareType: Int,
            public override val value1: String
        ) : SubscriberProperty() {
            override val value2: String? = null
        }

        @Serializable
        data class IntDataRule(
            override val fieldId: String,
            override val compareType: Int,
            public override val value1: Int,
            public override val value2: Int? = null
        ) : SubscriberProperty()

        @Serializable
        data class FloatDataRule(
            override val fieldId: String,
            override val compareType: Int,
            public override val value1: Float,
            public override val value2: Float? = null
        ) : SubscriberProperty()

        @Serializable
        data class DateDataRule(
            override val fieldId: String,
            override val compareType: Int,
            @Contextual public override val value1: Instant,
            @Contextual public override val value2: Instant? = null
        ) : SubscriberProperty()

        @Serializable
        data class BooleanDataRule(
            override val fieldId: String,
            override val compareType: Int,
            public override val value1: Boolean
        ) : SubscriberProperty() {
            override val value2: Boolean? = null
        }
    }

//    @Serializable
//    data class Order(val not: Boolean, val groups: List<String>, val items: List<String>) : Rule()
}

object CompareType {
    const val UNKNOWN = 0
    const val EQUALS = 1
//    const val NOT_EQUALS = -1

    const val CONTAINS = 10
    const val STARTS_WITH = 11
    const val ENDS_WITH = 12

    const val LESS = 20
    const val LESS_EQUALS = 21
    const val GREATER_EQUALS = 22
    const val GREATER = 23
    const val IN_RANGE = 24
//    const val NOT_IN_RANGE = -24

    const val LESS_THAN_DAYS_COUNT = 30
    const val GREATER_THAN_DAYS_COUNT = 31


    const val IN_LIST =
        40//Для поиска по пользовательским полям, что бы отобрать пользователей, у которых заполненно определенное свойство
//    const val NOT_IN_LIST =
//        41 //Для поиска по пользовательским полям, что бы отобрать пользователей, у которых не заполненно определенное свойство
    const val EMPTY_LIST = 42

    const val NOT_NULL = 50
    const val EXIST = 52
    const val IS_FILLED = 60
//    const val NOT_EMPTY = 70

}


//@Serializable
//sealed class Rule {
//
//    companion object {
//        fun registerSerializers(builder: SerializersModuleBuilder) = with(builder) {
//            polymorphic(Rule::class) {
//                subclass(RuleGroup::class)
//
//                subclass(RuleElement.SegmentsRules.StaticSegment::class)
//                subclass(RuleElement.SegmentsRules.DynamicSegment::class)
//
//                subclass(RuleElement.OrderRules.OrdersCount::class)
//                subclass(RuleElement.OrderRules.OrdersSum::class)
//                subclass(RuleElement.OrderRules.ProductPurchased::class)
//                subclass(RuleElement.OrderRules.ProductInCategoryPurchased::class)
//
//                subclass(RuleElement.EmailCampaignRules.Period::class)
//                subclass(RuleElement.EmailCampaignRules.ExactValue::class)
//            }
//        }
//    }
//
//    @Serializable
//    data class RuleGroup(
//        var andRuleOperator: Boolean = false,
//        val rules: MutableList<Rule> = mutableListOf()
//    ) : Rule()
//
//
//
//    @Serializable
//    sealed class RuleElement : Rule() {
//
////        @Serializable
////        data class ABSplit(
////            val splitValue: Int = 50
////        ) : RuleElement()
//
//        interface NegativeAllowedRule {
//            var not: Boolean
//        }
//
//        interface ExactValueRule {
//            var id: String
//        }
//
//        interface PeriodRule {
//            var start: String?
//            var end: String?
//        }
//
//
////        @Serializable
////        sealed class EventsRules : NegativeAllowedRule() {
////
////            @Serializable
////            data class EventPeriod(
////                val startDate: String = "",
////                val endDate: String = "",
////                override val not: Boolean = false
////            ) : EventsRules()
////        }
//
//        @Serializable
//        sealed class SegmentsRules : RuleElement(), ExactValueRule, NegativeAllowedRule {
//            @Serializable
//            data class DynamicSegment(
//                override var id: String = "",
//                override var not: Boolean = false
//            ) : SegmentsRules()
//
//            @Serializable
//            data class StaticSegment(
//                override var id: String = "",
//                override var not: Boolean = false
//            ) : SegmentsRules()
//        }
//
//        @Serializable
//        sealed class OrderRules : RuleElement(), PeriodRule, NegativeAllowedRule {
//            @Serializable
//            data class OrdersCount(
//                var minCount: Int? = 0,
//                var maxCount: Int? = null,
//                override var not: Boolean = false,
//                override var start: String? = null,
//                override var end: String? = null
//            ) : OrderRules()
//
//            @Serializable
//            data class OrdersSum(
//                var minSum: Float? = 0.0f,
//                var maxSum: Float? = null,
//                override var not: Boolean = false,
//                override var start: String? = null,
//                override var end: String? = null
//            ) : OrderRules()
//
//            @Serializable
//            data class ProductPurchased(
//                var products: List<String> = mutableListOf(),
//                var allProducts: Boolean = true,
//                override var not: Boolean = false,
//                override var start: String? = null,
//                override var end: String? = null
//            ) : OrderRules()
//
//            @Serializable
//            data class ProductInCategoryPurchased(
//                var categories: List<String> = mutableListOf(),
//                override var not: Boolean = false,
//                override var start: String? = null,
//                override var end: String? = null
//            ) : OrderRules()
//        }
//
//        @Serializable
//        sealed class EmailCampaignRules : RuleElement(), NegativeAllowedRule {
//            abstract var action: EmailCampaignRuleAction
//
//            @Serializable
//            enum class EmailCampaignRuleAction {
//                Sent,
//                Delivered,
//                Opened,
//                Clicked,
//            }
//
//            @Serializable
//            data class Period(
//                override var action: EmailCampaignRuleAction = EmailCampaignRuleAction.Sent,
//                override var not: Boolean = false,
//                override var start: String? = null,
//                override var end: String? = null
//            ) : EmailCampaignRules(), PeriodRule
//
//            @Serializable
//            data class ExactValue(
//                override var action: EmailCampaignRuleAction = EmailCampaignRuleAction.Sent,
//                override var not: Boolean = false,
//                override var id: String = ""
//            ) : EmailCampaignRules(), ExactValueRule
//        }
//    }
//}